import { Component, Input } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-disable-alert',
  templateUrl: './disable-alert.component.html',
  styleUrls: ['./disable-alert.component.scss'],
})
export class DisableAlertComponent {
  item: any = this.config.data;

  constructor(
    private ref: DynamicDialogRef, // private modalService: ModalService,
    private config: DynamicDialogConfig
  ) {}

  fecharDialog() {
    this.ref.close();
  }

  disableCard(item: any) {
    console.log(item);
  }
}
